import {
  Box,
  Text
} from "@chakra-ui/react";
import Lang from "../../Lang";

export default function StrategyBlock({ text1, text2 }) {
  return (
    <Box
      bg={"gray.900"}
      borderRadius={{ base: 30, md: 50, xl: 50 }}
      m={{ base: 6, md: 10, xl: 10 }}
      px={{ base: "25px", md: "60px", xl: "60px" }}
      py={{ base: "30px", md: "60px", xl: "60px" }}
      className="borderCard"
    >

      <Text
        color={"gray.50"}
        fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7em", xl: "2em" }}
        align={"left"}
      >
        <Lang text={text1} />
      </Text>

      <Text
        color={"gray.50"}
        fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7em", xl: "2em" }}
        align={"left"}
        mt={8}
      >
        <Lang text={text2} />
      </Text>

    </Box>

  );
}